export const reducerData = [
    'form',
    'options',
    'sub_options',
    'countries',
    'dashboard',
]